import { PreferredMainBetType, PreferredSoccerMainBetType } from '@nf/types/account';
import { matchEquals, matchSome } from '@nf/utils-common/fpw/monadic';
import { sportService } from '@/services/sport.service';

const getSortedMainBetTypes = (sport: number, preferredMainBetType: PreferredMainBetType): Array<number> => {
	const defaultBetTypes = sportService.getSportMainBetTypes(sport);
	const userPreferredMainBetType = preferredMainBetType[sport as keyof PreferredMainBetType];

	const sortedBetTypes: Array<number> = matchSome(sport)
		.on(
			() => [1, 997, 9995].includes(sport), 
			() => {
				const betTypes = matchEquals(userPreferredMainBetType)
					.on(PreferredSoccerMainBetType.Handicap, () => [1, 3, 5, 7, 8, 15])
					.on(PreferredSoccerMainBetType.OverUnder, () => [3, 1, 5, 8, 7, 15])
					.otherwise(() => [5, 1, 3, 15, 7, 8]);
				return betTypes;
			}
		)
		.otherwise(() => defaultBetTypes);

	return sortedBetTypes;
};

export const oddsPageService = {
	getSortedMainBetTypes
};